import { render, staticRenderFns } from "./SupportFormCard.vue?vue&type=template&id=0ad52ab4&scoped=true&"
import script from "./SupportFormCard.vue?vue&type=script&lang=js&"
export * from "./SupportFormCard.vue?vue&type=script&lang=js&"
import style0 from "./SupportFormCard.vue?vue&type=style&index=0&id=0ad52ab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad52ab4",
  null
  
)

export default component.exports